import { useMutation } from "@tanstack/react-query";
import { videoUpdate } from "common/api/unos_rad/unos_video";
import { useInvalidateQueryByKeys } from "hooks/query_common/useInvalidateQueryByKeys";
import { useQueryClient } from "@tanstack/react-query";
import { QUERY_KEYS } from "constant/react_query";

type UseUnosVideoUpdateParams = {
  invalidateKeys?: string[];
};

export const useUnosVideoUpdate = (hookParams?: UseUnosVideoUpdateParams) => {
  const queryClient = useQueryClient();
  const { invalidateQueriesByKeys } = useInvalidateQueryByKeys();
  const { mutate: videoUpdateMutate } = useMutation({
    mutationFn: async (params: any) =>
      await videoUpdate(params.id, params.updatePayload),
    onSuccess: () => {
      if (hookParams?.invalidateKeys) {
        invalidateQueriesByKeys(hookParams.invalidateKeys);
        queryClient.invalidateQueries({
          queryKey: [QUERY_KEYS.UNOS_VIDEO_GET],
        });
      }
    },
  });

  return { videoUpdateMutate };
};
